import type { ReactNode } from 'react';

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg-deep text-text-primary font-sans">
      {children}
    </div>
  );
}
